"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const BaseListBox_1 = tslib_1.__importDefault(require("./BaseListBox"));
const fmko_ts_common_1 = require("fmko-ts-common");
/**
 * Revisit this class, because it doesn't seem like FMK-Online uses a Map, but rather {[K: string]: T}
 */
/**
 * @deprecated use {@link GroupedDropdownWidget} instead.
 */
class GroupedListBox extends BaseListBox_1.default {
    constructor(element) {
        super(element);
    }
    setOptions(groupedOptions) {
        const selected = this.getValue();
        this.options = [];
        this.element.innerHTML = ""; // Clear all option elements from select element
        if (!groupedOptions || groupedOptions.size === 0) {
            return;
        }
        groupedOptions.forEach(value => {
            this.options.push(...value); // Flatmap
        });
        if (this.model.getTextForNoOptionSelected()) {
            const option = document.createElement("option");
            this.element.appendChild(option);
            option.text = this.model.getTextForNoOptionSelected();
            this.itemOffset = 1;
        }
        else {
            this.itemOffset = 0;
        }
        // Don't create a group if only a single key exists
        if (groupedOptions.size === 1) {
            groupedOptions.forEach(values => {
                values.forEach(item => {
                    const option = document.createElement("option");
                    this.element.appendChild(option);
                    option.value = this.model.formatItem(item);
                    fmko_ts_common_1.HTMLUtils.setSanitizedHTML(option, this.model.formatItem(item));
                });
            });
        }
        else { // go ahead and created groups (one per key)
            groupedOptions.forEach((value, key) => {
                const group = document.createElement("optgroup");
                this.element.appendChild(group);
                group.label = this.model.formatGroup(key);
                value.forEach(item => {
                    const option = document.createElement("option");
                    group.appendChild(option);
                    option.value = this.model.formatItem(item);
                    fmko_ts_common_1.HTMLUtils.setSanitizedHTML(option, this.model.formatItem(item));
                });
            });
            this.setValue(selected);
        }
        if (this.options.length === 1) {
            this.setValue(this.options[0], true);
        }
    }
    setUnknownValue(value) {
        if (!value) {
            this.element.selectedIndex = 0;
        }
        else {
            this.options.push(value);
            const group = document.createElement("optgroup");
            this.element.appendChild(group);
            group.label = "Ukendt værdi";
            const option = document.createElement("option");
            group.appendChild(option);
            option.text = this.model.formatItem(value);
            this.element.selectedIndex = this.itemOffset + this.options.length - 1;
        }
        return true;
    }
}
exports.default = GroupedListBox;
//# sourceMappingURL=GroupedListBox.js.map